import type { TaggingActionPayload, TaggingFeedback, TaggingViewPayload } from '../../models'

import type { TaggingService } from '../interfaces/tagging.service'

import { TaggingTypeEnum } from '../../enums'

export class TaggingLocalService implements TaggingService {
  tagView(instance: string, payload: TaggingViewPayload, sessionId: string): Promise<void> {
    return this.log(TaggingTypeEnum.VIEW, instance, payload, sessionId)
  }

  tagAction(instance: string, payload: TaggingActionPayload, sessionId: string): Promise<void> {
    return this.log(TaggingTypeEnum.ACTION, instance, payload, sessionId)
  }

  submitFeedback(instance: string, payload: TaggingFeedback, sessionId: string): Promise<void> {
    return this.log('feedback', instance, payload, sessionId)
  }

  private log(
    type: TaggingTypeEnum | 'feedback',
    instance: string,
    payload: TaggingViewPayload | TaggingActionPayload | TaggingFeedback,
    sessionId: string,
  ): Promise<void> {
    console.groupCollapsed('Debug Local tagging service')
    console.table({ sessionId, instance, type, ...payload })
    console.groupEnd()
    return Promise.resolve()
  }
}
